import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'

import Question from 'modules/quiz/components/Question'

const QuestionsPage = ({ match: { url } }) => (
  <>
    <Route exact path={url} render={() => <Redirect to={`${url}/1`} />} />

    <Route
      exact
      path={`${url}/:questionNumber`}
      render={props => <Question key={props.match.params.questionNumber} {...props} />}
    />
  </>
)

QuestionsPage.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      questionNumber: PropTypes.string,
    }),
  }).isRequired,
}

export default QuestionsPage
